import React from "react";
import { useNavigate } from "react-router-dom";
import "./AdminBackBar.css";

type Crumb = { label: string; to?: string };

interface Props {
    title?: string;
    crumbs?: Crumb[];
}

const AdminBackBar: React.FC<Props> = ({ title, crumbs }) => {
    const navigate = useNavigate();

    return (
        <div className="admin-backbar">
            <div className="admin-backbar-left">
                <button className="btn btn-secondary" type="button" onClick={() => navigate(-1)}>
                    ← Tilbage
                </button>

                <button className="btn btn-ghost" type="button" onClick={() => navigate("/admin")}>
                    Admin menu
                </button>

                {title && <div className="admin-backbar-title">{title}</div>}
            </div>

            {crumbs?.length ? (
                <div className="admin-backbar-crumbs">
                    {crumbs.map((c, i) => (
                        <span key={i} className="crumb">
                            {c.to ? (
                                <button
                                    type="button"
                                    className="crumb-link"
                                    onClick={() => navigate(c.to!)}
                                >
                                    {c.label}
                                </button>
                            ) : (
                                <span className="crumb-current">{c.label}</span>
                            )}
                            {i < crumbs.length - 1 && <span className="crumb-sep">/</span>}
                        </span>
                    ))}
                </div>
            ) : null}
        </div>
    );
};

export default AdminBackBar;